import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { List } from "../generic/list/List";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { ProfilePicture } from "../player-profile/ProfilePicture";
export var ListPictureRewards = function (_a) {
    var items = _a.items;
    var renderItem = function (_a) {
        var icon = _a.icon, amount = _a.amount;
        return (React.createElement("div", { className: "flex flex--stacked flex--guts padding--small" },
            React.createElement("div", { className: IdStyles.ProfilePictureWrapper + " flex flex--guts" },
                React.createElement("div", { className: "" + IdStyles.ProfilePictureContainer },
                    React.createElement(ProfilePicture, { profilePictureSize: IdStyles.ProfilePictureSmall, profilePictureName: icon, profilePictureClassName: "profile-pictures__container-item" }))),
            React.createElement(NumberFormat, { amount: amount, format: TypeNumberFormat.Percent, className: IdStyles.TextSmallBoldSecondaryOutline })));
    };
    return (React.createElement(List, { className: "flex flex--wrap padding--small", items: items, renderItem: renderItem }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/ListPictureRewards.tsx
// module id = 2930
// module chunks = 3